import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  CURRENCY_FEATURE_KEY,
  CurrencyState,
  CurrencyPartialState,
  currencyAdapter
} from './currency.reducer';

// Lookup the 'Currency' feature state managed by NgRx
export const getCurrencyState = createFeatureSelector<
  CurrencyPartialState,
  CurrencyState
>(CURRENCY_FEATURE_KEY);

const { selectAll, selectEntities } = currencyAdapter.getSelectors();

export const getCurrencyLoaded = createSelector(
  getCurrencyState,
  (state: CurrencyState) => state.loaded
);

export const getCurrencyError = createSelector(
  getCurrencyState,
  (state: CurrencyState) =>  state.error
);

export const loadingCurrency = createSelector(
  getCurrencyState,
  (state: CurrencyState) =>  state.loaded
);

export const getAllCurrency = createSelector(
  getCurrencyState,
  (state: CurrencyState) => selectAll(state)
);

export const getCurrencyEntities = createSelector(
  getCurrencyState,
  (state: CurrencyState) => selectEntities(state)
);

export const getSelectedId = createSelector(
  getCurrencyState,
  (state: CurrencyState) => state.selectedCurrencyId
);

export const getSelected = createSelector(
  getCurrencyEntities,
  getSelectedId,
  (entities, selectedId) => selectedId && entities[selectedId]
);
